module.exports = __webpack_public_path__ + "static/media/pdflogo.9843760d.png";